export default "__VITE_ASSET__BdZTbQOS__"